import axios from 'axios'
import store from '../../store/index'

const state = {
  appSubscriptions: [],
  appSubscriptionPrices: [],
  appSubscriptionTypes: [],
}

const mutations = {
  appSubscriptions_data (state, appSubscriptions) {
    state.appSubscriptions = appSubscriptions
  },
  appSubscriptionPrices_data (state, appSubscriptionPrices) {
    state.appSubscriptionPrices = appSubscriptionPrices
  },
  appSubscriptionTypes_data (state, appSubscriptionTypes) {
    state.appSubscriptionTypes = appSubscriptionTypes
  },
}

const actions = {
  createAppSubscription ({ commit }, appSubscription) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions',
        data: appSubscription,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateAppSubscription ({ commit }, appSubscription) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions?appSubscriptionId=' + appSubscription.appSubscriptionId,
        data: appSubscription.message,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateAppSubscriptionEvents ({ commit }, appSubscription) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions/patchEvents?subscriptionId=' + appSubscription.subscriptionId,
        data: { message: appSubscription.message },
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteAppSubscription ({ commit }, appSubscriptionId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions?appSubscriptionId=' + appSubscriptionId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteAppSubscriptionEvents ({ commit }, eventAppSubscriptionId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions/deleteEvents?eventAppSubscriptionId=' + eventAppSubscriptionId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions/list',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appSubscriptions_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getLocationAppSubscriptions ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions/list/location/?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppSubscription ({ commit }, subscriptionId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions?appSubscriptionId=' + subscriptionId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppSubscriptionTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSubscriptions/types',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appSubscriptionTypes_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppSubscriptionPrices ({ commit }, appSubscriptionId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '​/appSubscriptions/prices?appSubscriptionId=' + appSubscriptionId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appSubscriptionPrices_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
